var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquareLogoBvvm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.443 9H24.1C13.672 9 9.492 16.276 9.049 23.081c-.024.323-.024.621-.049.919 0 .298.025.62.05.919C9.491 31.724 13.671 39 24.098 39h.344c10.427 0 14.607-7.276 15.05-14.081.025-.323.025-.621.05-.919 0-.298-.025-.62-.05-.919C39.05 16.276 34.87 9 24.443 9zm8.361 15.497c-.098 1.54-.516 3.725-1.967 5.389-1.377 1.564-3.541 2.384-6.394 2.384H24.1c-2.877 0-5.017-.795-6.394-2.384-1.45-1.64-1.869-3.825-1.967-5.39 0-.148-.025-.322-.025-.496s0-.323.025-.497c.098-1.54.516-3.725 1.967-5.389 1.377-1.564 3.541-2.384 6.394-2.384h.344c2.877 0 5.017.795 6.394 2.384 1.45 1.64 1.869 3.825 1.967 5.39 0 .148.025.322.025.496s-.025.323-.025.497z",
    fill: "var(--color-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareLogoBvvm);
export default __webpack_public_path__ + "static/media/squareLogoBvvm.7a7b909931952dae201c30c32fe4d2a8.svg";
export { ForwardRef as ReactComponent };